export const CUSTOM_EDGE = 'CUSTOM_EDGE';
export const CUSTOM_EDGE_DASHED = 'CUSTOM_EDGE_DASHED';

export const GRAPH_LAYOUT_TYPE = 'dagre';
export const GRAPH_DIRECTION = 'LR';
export const GRAPH_ALIGNMENT = 'UL';
export const ENTRY_TRIGGER = 'ENTRY_TRIGGER';
export const DECISION_SPLIT = 'DECISION_SPLIT';
export const EXIT_TRIGGER = 'EXIT_TRIGGER';
export const WAIT_TILL_EVENT = 'WAIT_TILL_EVENT';
export const EMPTY_GRAPH_TEXT = 'EMPTY_GRAPH_TEXT';
export const PLACEHOLDER_NODE = 'PLACEHOLDER_NODE';
export const END_NODE = 'END_NODE';
export const BLOCK_NODE = 'BLOCK_NODE';
export const SCHEDULE_BLOCK = 'SCHEDULE_BLOCK';

export const DELETE = 'delete';
export const SETTINGS = 'settings';
export const COPY = 'copy';
export const VIEW = 'view';
export const SWAP = 'swap';
export const EDIT = 'edit';

export const SOURCE_COORDINATES = { x: 318, y: 56 };
export const JOIN = 'JOIN';
export const JUMP = 'JUMP';
export const JOIN_NOTIFICATION_STYLE = {
    minWidth: '514px',
    position: 'absolute',
    right: '0px',
    top: '96px',
};
export const CHANNEL_TO_ICONS_MAPPING = {
    EMAIL: 'messageWithTransform',
    SMS: 'sms',
    MPUSH: 'mpush',
    AB_TESTING: 'ab-testing',
    ZALO : 'zalo',
    CHANNEL_PRIORITY: 'channelPriority',
};
export const EMAIL = 'EMAIL';

export const BLOCKS_FOR_EDIT_ICON = ['join', 'jump', 'alarm', 'waitEvent'];
export const LIVE = "LIVE";
export const RUNNING = "RUNNING";
export const RESULT_AWAITING = "RESULT_AWAITING";
export const SUCCESS = 'SUCCESS';
export const IN_PROGRESS = 'IN_PROGRESS';
export const NANO_ID_LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
export const NANO_ID_DIGITS = '0123456789';